module.exports = __webpack_public_path__ + "static/ConcishareFormHeader-154210b674a2e5fb85f9869a23488124.png";